
import { combineReducers } from '@reduxjs/toolkit';
import siteDataReducer from "@/entities/site_data/model/slice";
import mapFilterReducer from "@/features/map_filter/model/slice";
import modalReducer from "@/widgets/modal/model/slice";
import searchReducer from "@/features/search/model/slice";

export const rootReducer = combineReducers({
    siteData: siteDataReducer,
    mapFilterData: mapFilterReducer,
    modal: modalReducer,
    search: searchReducer
})